import React, { useState, useEffect } from 'react';
import {
  ArquivoContratoAditivo,
  getAllArquivoContratoAditivoPorAditivoId,
  excluirAquivoAditivoDoContrato,
  getAquivoAditivoDoContrato,
  viewAquivoAditivoDoContrato,
} from '../../../api/contrato/aditivosContrato';
import { Table, Button, ButtonDelete, usePromise } from '@digital/ui';
import { Tooltip } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import { GetFileExtension, imageFormats } from '@app/helpers';

interface PropsAditovoArquivos {
  aditivoId: string;
  atualizarTela: boolean;
}

const TabelaArquivoAditvo = (props: PropsAditovoArquivos) => {
  const { aditivoId, atualizarTela } = props;
  const [arquivoContratoAditivo, setArquivoContratoAditivo] = useState<ArquivoContratoAditivo[]>();
  const [atualizarExcluir, setAtualizarExcluir] = useState(true);

  useEffect(() => {
    getData();
  }, [atualizarTela, atualizarExcluir]);

  const getData = async () => {
    const result = await getAllArquivoContratoAditivoPorAditivoId(aditivoId);
    if (result) setArquivoContratoAditivo(result);
  };

  const excluirArquivo = async (arquivoId: string) => {
    const result = await excluirAquivoAditivoDoContrato(arquivoId);
    if (result) {
      setAtualizarExcluir(!atualizarExcluir);
    }
  };

  const baixarArquivo = (arquivoId: string, nomeDoArquivo: string) => {
    getAquivoAditivoDoContrato(arquivoId, nomeDoArquivo);
  };

  const viewArquivo = (arquivoId: string, nomeDoArquivo: string) => {
    viewAquivoAditivoDoContrato(arquivoId, nomeDoArquivo);
  };

  const columns = [
    {
      title: 'Número',
      dataIndex: 'numero',
      width: '5%',
    },
    {
      title: 'Nome',
      dataIndex: 'nome',
      width: '20%',
    },
    {
      title: 'Inclusão',
      dataIndex: 'dataInclusaoFormatada',
      width: '20%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      width: '20%',
    },
    {
      title: 'Ações',
      dataIndex: '',
      key: 'x',
      width: '5%',
      render: record => (
        <>
          {hasPermission(['CONTRATO_GERAL_ANEXOS_CONTRATO_ADITIVOS']) ? (
            <>
              <Tooltip title="Deletar Item">
                <ButtonDelete
                  onClick={() => {
                    excluirArquivo(record.id);
                  }}
                  name="btnExcluirItem"
                  icon="science-minus"
                  confirm="Deseja realmente excluir este registro?"
                  okText="Confirmar"
                  className="btn-delete-without-text"
                />
              </Tooltip>
              <Tooltip title="Baixar Arquivo">
                <Button
                  onClick={() => {
                    baixarArquivo(record.id, record.nome);
                  }}
                  icon="ui-download"
                  name="btnBaixarArquivo"
                />
              </Tooltip>
              {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    onClick={async () => {
                      await viewArquivo(record.id, record.nome);
                    }}
                    icon="files-view_file"
                    name="btnViewArquivo"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              <>
                <Tooltip title="Baixar Arquivo">
                  <Button
                    onClick={() => {
                      baixarArquivo(record.id, record.nome);
                    }}
                    icon="ui-download"
                    name="btnBaixarArquivo"
                  />
                </Tooltip>
                {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      onClick={async () => {
                        await viewArquivo(record.id, record.nome);
                      }}
                      icon="files-view_file"
                      name="btnViewArquivo"
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <Table rowKey="id" columns={columns} dataSource={arquivoContratoAditivo} pagination={false} />
    </>
  );
};

export default TabelaArquivoAditvo;
